<template>
	<div class="matchingResult">
		<!-- 页头 -->
		<div class="title">
			<div class="title_left">
				<span class="title_text">匹配结果</span>
				<span class="fileName">文件名：{{ matchingData.fileName }}</span>
			</div>
			<div class="title_right">
				<el-button type="primary" @click="reUpload">重新上传</el-button>
			</div>
		</div>

		<!-- 时间展示 -->
		<div class="time-card-wrap">
			<div class="time-card">
				<!-- 左区域 -->
				<div class="card-left">
					<div class="label-text">本次匹配时间</div>
					<div class="big-time">{{ matchingData.matchTime }}</div>
				</div>
				<!-- 右区域 -->
				<div class="card-right">
					<div class="label-text">影响周报日期　下次发送时间</div>
					<div class="big-time">{{ initTimeData }}</div>
					<div class="tip-text">
						每周一 10:30 发送（比源时间），需在此时间前上传；逾期上传，本次周报将不包含余额信息。
					</div>
				</div>
			</div>
		</div>

		<!-- 匹配数据条数展示 -->
		<div class="num_show">
			<div class="num_item">
				<div class="num_title">
					<span class="num_title_text">Excel 总数据条数</span>
					<sup class="el-badge__content is-dot"></sup>
				</div>
				<div class="num_text">
					<span class="num">{{ matchingData.totalCount }}</span>
					<span class="num_unit">条</span>
				</div>
			</div>
			<div class="num_item">
				<div class="num_title">
					<span class="num_title_text">匹配成功</span>
					<sup class="el-badge__content is-dot success"></sup>
				</div>
				<div class="num_text">
					<span class="num success">{{ matchingData.matchedCount }}</span>
					<span class="num_unit">条</span>
				</div>
			</div>
			<div class="num_item">
				<div class="num_title">
					<span class="num_title_text">匹配失败</span
					><sup class="el-badge__content is-dot error"></sup>
				</div>
				<div class="num_text">
					<span class="num error">{{ matchingData.unmatchedCount }}</span>
					<span class="num_unit">条</span>
				</div>
			</div>
			<div class="num_item">
				<div class="num_title">
					<span class="num_title_text">匹配成功率</span><sup class="el-badge__content is-dot"></sup>
				</div>
				<div class="num_text">
					<span class="num">{{ successRate }}</span>
					<span class="num_unit">%</span>
				</div>
			</div>
		</div>

		<!-- 筛选 -->
		<filter-panel
			style="width: 100%"
			:data="group"
			:hideResult="true"
			@search="filterChange"
		></filter-panel>

		<!--明细列表 -->
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:page="page"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';

import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import dayjs from 'dayjs';
import 'dayjs/plugin/weekday';

dayjs.extend(require('dayjs/plugin/weekday'));

const page = listPageCreate({
	searchConfig: {
		api: api.googleAds.balanceMatchList,
		method: 'POST',
	},
	getQuery(obj, that) {
		let { matchingData } = that;
		let { batchId, batchNo } = matchingData;
		return _.assign(obj, {
			batchId,
			batchNo,
		});
	},
});

export default {
	name: 'matchingResult',
	props: ['matchingData'],
	components: {
		filterPanel,
	},
	mixins: [page],
	data() {
		return {
			group: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '客户名称',
						label: '客户名称',
						prop: 'customerName',
						value: '',
					},
					{
						tagName: 'sky-input',
						placeholder: '服务单号',
						label: '服务单号',
						prop: 'serviceCode',
						value: '',
					},
					{
						tagName: 'sky-input',
						placeholder: 'CID',
						label: 'CID',
						prop: 'cid',
						value: '',
					},
					{
						tagName: 'sky-select',
						placeholder: '匹配状态',
						label: '匹配状态',
						value: '',
						prop: 'matchStatus',
						options: [
							{
								value: 0,
								label: '不匹配',
							},
							{
								value: 1,
								label: '已匹配',
							},
						],
					},
				],
			},
			columns: [
				{
					label: '源行',
					bind: 'rowNum',
					width: 50,
				},
				{
					label: '客户名称',
					bind: 'customerName',
				},
				{
					label: '服务单号',
					bind: 'serviceCode',
				},
				{
					label: 'cid',
					bind: 'cid',
				},
				{
					label: '当期余额（元）',
					bind: 'currentBalance',
					width: 150,
				},
				{
					label: '匹配状态',
					bind: val => {
						let { matchStatus } = val;
						switch (matchStatus - 0) {
							case 0:
								return '不匹配';
							case 1:
								return '已匹配';
						}
						return '-';
					},
					width: 80,
				},
				{
					label: '失败原因',
					bind: 'mismatchReason',
				},
				{
					label: '创建人名称',
					bind: 'createrName',
					width: 100,
				},
				{
					label: '创建时间',
					bind: 'createTime',
				},
				{
					label: '修改人名称',
					bind: 'modifierName',
					width: 100,
				},
				{
					label: '修改时间',
					bind: 'modifiedTime',
				},
			],
		};
	},
	computed: {
		// 成功率计算
		successRate(that) {
			let { matchingData } = that;
			let { matchedCount, totalCount } = matchingData;
			if (totalCount === 0) return '0.0';
			const rate = (matchedCount / totalCount) * 100;
			return rate.toFixed(1);
		},
		// 下周1时间获取
		initTimeData() {
			// 👉 dayjs() 默认读取本机电脑系统时间
			const now = dayjs();

			// 先拿到【本周一 10:30】
			const thisMonday1030 = dayjs().weekday(1).hour(10).minute(30).second(0);
			let nextMonday;

			if (now.isAfter(thisMonday1030)) {
				// ✅ 当前时间 > 本周一10:30 → 取下一周周一10:30
				nextMonday = thisMonday1030.add(1, 'week');
			} else {
				// ✅ 当前还没到本周一10:30 → 使用本周一10:30
				nextMonday = thisMonday1030;
			}

			return nextMonday.format('YYYY-MM-DD HH:mm') + '（周一）';
		},
	},
	mounted() {
		this.query();
	},
	methods: {
		// 重新上传
		reUpload() {
			this.$emit('reUpload');
		},
	},
};
</script>

<style lang="scss" scoped>
.matchingResult {
	.title {
		margin-bottom: 10px;
		background-color: white;
		border: 1px solid rgba(234, 230, 230, 0.783);
		border-radius: 5px;
		padding: 10px;
		height: 50px;
		display: flex;
		align-items: center;
		flex-direction: row;
		justify-content: space-between;

		.title_left {
			.title_text {
				margin-right: 10px;
				font-size: 19px;
				font-weight: 600;
			}

			.fileName {
				color: #7d899c;
			}
		}

		.title_right {
		}
	}

	.time-card-wrap {
		margin-bottom: 10px;

		.time-card {
			display: flex;
			background-color: #f0f5ff;
			border: 1px solid #c6dafc;
			border-left: 4px solid #4078f2;
			border-radius: 4px;
			padding: 16px 20px;
			gap: 40px;
			align-items: center;

			.card-left {
				flex-shrink: 0;

				.label-text {
					font-size: 16px;
					color: #333;
					margin-bottom: 8px;
				}
				.big-time {
					font-size: 30px;
					color: #003399;
					font-weight: 500;
				}
			}

			.card-right {
				flex: 1;
				border-left: 1px solid #ccdaf0;
				padding-left: 40px;

				.label-text {
					font-size: 16px;
					color: #333;
					margin-bottom: 8px;
				}
				.big-time {
					font-size: 30px;
					color: #003399;
					font-weight: 500;
				}
				.tip-text {
					margin-top: 12px;
					font-size: 16px;
					color: #444;
					line-height: 1.6;
				}
			}
		}
	}

	.num_show {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr 1fr;
		grid-column-gap: 20px;
		margin-bottom: 10px;

		.num_item {
			background-color: white;
			border: 1px solid rgba(234, 230, 230, 0.783);
			border-radius: 5px;
			height: 100px;
			padding: 15px 25px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.num_title {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.num_title_text {
					font-size: 15px;
					color: #9eaaba;
				}

				sup {
					width: 10px;
					height: 10px;
					top: 0px;
					background-color: #9eaaba;
				}

				.success {
					background-color: #128466;
				}

				.error {
					background-color: #d15c59;
				}
			}

			.num_text {
				.num {
					font-size: 30px;
					margin-right: 5px;
				}

				.num_unit {
					font-size: 15px;
					color: #9eaaba;
				}
			}

			.success {
				color: #128466;
			}

			.error {
				color: #d15c59;
			}
		}
	}
}
</style>
